import { render, staticRenderFns } from "./TableSkeleton.global.vue?vue&type=template&id=779a2e4a&scoped=true&lang=pug&"
import script from "./TableSkeleton.global.vue?vue&type=script&lang=ts&"
export * from "./TableSkeleton.global.vue?vue&type=script&lang=ts&"
import style0 from "./TableSkeleton.global.vue?vue&type=style&index=0&id=779a2e4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "779a2e4a",
  null
  
)

export default component.exports